import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { scrollStore } from "./lib/scroll";
import { Nav } from "./components/sora/Nav";
import { Footer } from "./components/sora/Footer";
import { Cursor } from "./components/sora/Cursor";
import { Preloader } from "./components/sora/Preloader";
import Home from "./pages/Home";
import CaseStudy from "./pages/CaseStudy";

function Shell({ start }) {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      scrollStore.scrollTo(id);
    }
  };

  return (
    <div className="bg-ivory font-sans text-ink" data-testid="sora-app">
      <Cursor />
      <Nav onNavigate={go} />
      <Routes>
        <Route path="/" element={<Home start={start} />} />
        <Route path="/work/:slug" element={<CaseStudy />} />
      </Routes>
      <Footer onNavigate={go} />
    </div>
  );
}

function App() {
  const [loading, setLoading] = useState(() => {
    try {
      return !window.localStorage.getItem("sora-returning");
    } catch {
      return true;
    }
  });

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.5,
      smoothWheel: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    scrollStore.lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      scrollStore.lenis = null;
    };
  }, []);

  useEffect(() => {
    if (!loading) return;
    const t = setTimeout(() => {
      setLoading(false);
      try {
        window.localStorage.setItem("sora-returning", "1");
      } catch {}
    }, 2600);
    return () => clearTimeout(t);
  }, [loading]);

  useEffect(() => {
    if (!scrollStore.lenis) return;
    if (loading) scrollStore.lenis.stop();
    else scrollStore.lenis.start();
  }, [loading]);

  return (
    <BrowserRouter>
      <AnimatePresence>
        {loading && <Preloader key="preloader" />}
      </AnimatePresence>
      <Shell start={!loading} />
    </BrowserRouter>
  );
}

export default App;
